<!--红包内容-->
<template>
  <div class="redmain-page">
    <!--登录的-->
    <template v-if="isLogined">
      <!--步骤1-显示领取按钮-->
      <template v-if="redAction.showbtn === 1">
        <template v-if="['themeKYMN'].includes(THEME)">
          <div class="redmain-small">
            <div class="redmain-small-top text-center">
              <van-button class="opnen-btn text-center d-block fz-16" :loading="redAction.isreq" @click.stop="redAction.open()"></van-button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="redmain-small">
            <div class="redmain-small-top text-center">
              <van-button class="opnen-btn text-center d-block fz-16" :loading="redAction.isreq" @click.stop="redAction.open()"></van-button>
              <!--<p class="item-name fz-14 text-ellipsis" v-text="$t('恭喜您抽中')"></p>
              <p class="item-value fz-16" v-text="`${BL()}${redAction.hbItem.total_amount || 0}`"></p>-->
            </div>
            <!--<template v-if="redAction.isloading">
              <div class="redmain-small-bottom text-center">
                <span class="fz-16" v-text="`${$t('正在获取红包')}...`"></span>
              </div>
            </template>
            <template v-else>
              <van-button class="redmain-small-bottom text-center d-block" :loading="redAction.isreq" @click.stop="redAction.open()">
                <span class="fz-16" v-text="$t('前往领取')"></span>
              </van-button>
            </template>-->
          </div>
        </template>
      </template>
      <!--步骤2-点击了领取按钮-->
      <template v-else>
        <!--大红包背景-->
        <div class="redmain-big">
          <!--提示注册会员按钮或者显示红包价值或者未满足条件-->
          <div class="redmain-top">
            <div class="redmain-top-main islogined">
              <template v-if="redAction.success">
                <span class="fz-18 fw-bold text-red" v-text="`${BL()}${redAction.success}`"></span>
              </template>
              <template v-else>
                <span class="fz-14 error" v-text="$t(redAction.errorText)"></span>
              </template>
            </div>
          </div>
          <!--活动规则-->
          <div class="redmain-rult-box">
            <div class="rult-title text-center">
              <span class="text-ellipsis d-block fz-14" v-text="$t('活动介绍')"></span>
            </div>
            <div class="rule-cont-warp">
              <div class="rule-cont" v-html="redRult"></div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <!--未登录-->
    <template v-else>
      <!--大红包背景-->
      <div class="redmain-big">
        <!--提示注册会员按钮或者显示红包价值或者未满足条件-->
        <div class="redmain-top">
          <div class="redmain-top-main unlogin" @click.stop="$router.push('/login')">
            <span class="fz-16 fw-bold" v-text="$t('立即注册会员')"></span>
          </div>
        </div>
        <!--活动规则-->
        <div class="redmain-rult-box">
          <div class="rult-title text-center">
            <span class="text-ellipsis fz-14" v-text="$t('活动介绍')"></span>
          </div>
          <div class="rule-cont-warp">
            <div class="rule-cont-txt fz-16 text-center" v-text="$t('请登录')"></div>
          </div>
        </div>
      </div>
    </template>
    <div class="redmain-bottom">
      <div class="bottom-close d-flex align-items-center justify-content-center">
        <van-icon name="close" @click="$emit('close', false)" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, reactive, ref} from 'vue'
import {checkActivityState, getHBOne, getHBRules, openHBOne} from "/@/hooks/userActions.ts";
import {useHot} from "/@/kernel-mn/stores/useHot.ts";
import {mb_err, mb_t, mb_toast} from "/@/plugins/global.ts";
import {accMul} from "/@/kernel-mn/utils";

export default defineComponent({
  name: "RedMain",
  emits: ["close"],
  setup() {
    const {hotData: {isLogined}} = useHot();
    // 领取红包步骤动作 showbtn:显示按钮 isreq:是否在领取中 open:领取
    const redAction = reactive({
      showbtn: 1,
      isloading: false, // 请求红包中
      isreq: false,
      hbItem: <any> {}, // 红包数据
      success: 0, // 成功就是领取的钱
      errorText: '未达成条件',
      // 一个红包对象
      open: (item:any = {}) => {
        item = item.id? item: redAction.hbItem;
        if (!item.id) {
          return mb_toast(mb_t('暂时没有红包哟'));
        }
        // 判断红包是否有效
        const now = Date.now();
        if (now < item.start_time || now > item.end_time) {
          return mb_toast(mb_t('还未到抢红包时间'))
        };
        // state 1领取 2已领取
        if (redAction.hbItem.state !== 1) {
          return mb_toast(mb_t('已失效'), 2);
        };
        if(redAction.isreq){
          return 
        }
        redAction.isreq = true;
        // 需要先检查状态
        checkActivityState({activity_name: 'hongbaoyu', red_packet_id: item.id,}).then((res:any) => {
          if (res?.response_code === '9999') {
            openHBOne({id: item.id}).then((res1:any) => {
              redAction.isreq = false;
              redAction.showbtn = 2; // 显示领取结果
              if (res1) {
                if (res1.amount) {
                  redAction.success = +accMul(res1.amount, 0.001, 0) || 0;
                } else {
                  redAction.errorText = '已失效';
                }
                redAction.hbItem.state = 2; // 改变当前红包状态
              } else {
                mb_toast(mb_t('领取失败'), 2)
              }
            }).catch((err) => {
              redAction.isreq = false; // 领取失败详情
              err?.info && (redAction.errorText = err?.info); // 领取失败详情
              mb_err(err?.info, 2)
            })
          } else {
            redAction.isreq = false;
            mb_toast(mb_t('领取失败'), 2);
          }
        }).catch(err => {
          redAction.isreq = false;
          mb_err(err?.info, 2); // 检查状态失败
        });
      },
      // 获取一个红包
      getOne: () => {
        redAction.isloading = true;
        getHBOne().then((res:any) => {
          redAction.hbItem = {...(res || {}), total_amount: +accMul(res.total_amount, 0.001, 0) || 0};
        }).finally(() => {
          redAction.isloading = false;
        });
      }
    });
    const redRult = ref(''); // 红包规则
    const getRult = () => {
      getHBRules().then((res:any) => {
        redRult.value = res?.data[0]?.value
      });
    };
    // 登录才执行
    if (isLogined.value) {
      redAction.showbtn = 1; // 纠错 打开弹窗始终显示步骤1
      redAction.getOne(); // 获得一个红包
      getRult();
    }
    return {
      isLogined,
      redRult,
      redAction,
    }
  }
})
</script>

<style scoped lang="scss">
.redmain-page {
  // 步骤1 显示领取按钮页
  .redmain-small {
    width: px2rem(332);height: px2rem(405);margin: 0 auto;
    .redmain-small-top {
      width: px2rem(92);height: px2rem(190);@include bgFull(publicImgUrl('hongbao/red_pack_small.png'));
      padding: px2rem(185) px2rem(120) px2rem(30);
    }
    .opnen-btn {
      background: none;width: px2rem(92);height: px2rem(90);color: var(--btn_text_color);
      :deep(.van-button__loading .van-loading__spinner) {
        width: px2rem(32);height: px2rem(32);
      }
    }
    .item-name {
      line-height: px2rem(24);
    }
    .redmain-small-bottom {
      width: px2rem(150);height: px2rem(38);@include bgFull(publicImgUrl('hongbao/red_pack_small_btn.png'));
      margin: 0 auto;padding: px2rem(5) px2rem(10) px2rem(25);color: var(--btn_text_color);box-sizing: content-box;
      span {
        line-height: px2rem(38);display: block;@include text-overflow();
      }
    }
  }
  // 大红包背景
  .redmain-big {
    width: px2rem(228);height: px2rem(215);@include bgFull(publicImgUrl('hongbao/red_pack_big.png'));
    padding-top: px2rem(156);margin: 0 auto;
    // 顶部
    .redmain-top {
      height: px2rem(50);padding: 0 px2rem(10);
      .redmain-top-main {
        padding: px2rem(10);line-height: px2rem(30);text-align: center;
        span {
          display: block;@include text-overflow();
        }
      }
      .unlogin {
        background: linear-gradient(180deg, #FED865, #FFE495);color: var(--primary);border-radius: px2rem(25);
      }
      .islogined {
        @include bgFull(publicImgUrl('hongbao/red_pack_res.png'));padding-left: px2rem(60);
      }
      .error {
        background: #C8C199;border-radius: px2rem(16);
      }
    }
    // 规则介绍
    .redmain-rult-box {
      padding: px2rem(10);
      .rult-title {
        padding: 0 px2rem(10) px2rem(10);height: px2rem(24);line-height: px2rem(24);color: #FFF7CC;
        span {
          max-width: calc(100% - #{px2rem(20)});padding: 0 px2rem(10);background: #AA000B;border-radius: px2rem(12);
          display: inline-block;
        }
      }
      .rule-cont-warp {
        height: px2rem(106);overflow: auto;overflow-x: hidden;color: #FFF7CC;
      }
      .rule-cont-txt {
        color: #FFF7CC;
      }
    }
  }
  .redmain-bottom {
    margin-top: px2rem(6);
    .bottom-close {
      height: px2rem(36);color: #fff;
      .van-icon-close {
        font-size: px2rem(36);line-height: px2rem(36);
      }
    }
  }
}
// 主题
.themeKYMN {
  .redmain-page {
    // 步骤1 显示领取按钮页
    .redmain-small {
      width: px2rem(342);height: px2rem(356);
      .redmain-small-top {
        width: px2rem(102);height: px2rem(100);@include bgFull(publicImgUrl('hongbao/red_pack_small1.png'));
        padding: px2rem(226) px2rem(120) px2rem(30);
      }
      .opnen-btn {
        width: px2rem(102);height: px2rem(100);
      }
    }
    // 大红包背景
    .redmain-big {
      width: px2rem(330);height: px2rem(290);@include bgFull(publicImgUrl('hongbao/red_pack_big1.png'));
      padding-top: px2rem(190);
      // 顶部
      .redmain-top {
        padding: 0 px2rem(55);
        .unlogin {
          background: linear-gradient(180deg, #F6D468, #FEF8E7);color: #AA350B;
        }
        .islogined {
          @include bgFull(publicImgUrl('hongbao/red_pack_res1.png'));padding-left: px2rem(70);
        }
        .text-red {
          color: #A50A00;
        }
        .error {
          background: linear-gradient(180deg, #B5B5B5, #8A8A8A);color: var(--btn_text_color);
        }
      }
      // 规则介绍
      .redmain-rult-box {
        padding: px2rem(15) px2rem(28);
        .rult-title {
          @include flexStyle();
          &:after, &:before {
            content: '';width: px2rem(50);height: px2rem(1);flex-shrink: 0;background: #E3584A;margin: 0 px2rem(4);
          }
          span {
            background: #E3584A;
          }
        }
        .rule-cont-warp {
          height: px2rem(126);color: #FFF5D3;
        }
      }
    }
    .redmain-bottom {
      margin-top: px2rem(20);
      .bottom-close {
        .van-icon-close {
          @include bgSvg(36, 36, 0, url(publicImgUrl('download-close.svg')), 0);
          &:before {
            display: none;
          }
        }
      }
    }
  }
}
</style>